exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.our-sponsors{background-color:#E7EBD2;padding:5px 0\n}\n.our-sponsors ul{list-style:none;text-align:center\n}\n.our-sponsors ul li{display:inline-block\n}\n", ""]);

// exports
